import React from "react";
import Header from "./Header";
import Footer from "./Footer";

const HomeLayout = ({ children, className }) => {
  return (
    <div className={`${className} `}>
      <Header
        position={"absolute left-1/2 translate-x-[-50%] backdrop-blur-sm"}
        bg={"bg-[rgba(255,255,255,0.4)]"}
      />

      <main className={`bg-white `}>{children}</main>
      <Footer />
    </div>
  );
};

export default HomeLayout;
